export default {
  bdtx_get_overview_module: 'bdtx/assign-module/assign-module-material/list',
  bdtx_assign_material: 'bdtx/assign-module/assign-module-material/update',
  bdtx_get_deal: '/bdtx/deal/api/list',
};
